/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { IEnvironmentConfig } from "src/app/shared/interfaces/IEnvironmentConfig";
import { DoctorDto } from "../models/http/doctor-dto";
import { TxCoordinatorDto } from "../models/http/tx-coordinator-dto";

/** Credentials to be used when interacting with OrthoFi APIs */
const httpOptions = { withCredentials: true };

@Injectable({
  providedIn: "root",
})
export class PracticeContractConfigurationService {
  private apiRoot = "https://gatekeeper.orthofi.com";

  constructor(
    @Inject("ENV") private _env: IEnvironmentConfig,
    private _http: HttpClient
  ) {
    this.apiRoot = `${_env.gatekeeperUrl}/api/v1`;
  }

  public getDoctors(practiceId: number): Observable<DoctorDto[]> {
    return this._http.get<any[]>(
      `${this.apiRoot}/practice/doctors/list?practiceId=${practiceId}`,
      httpOptions
    );
  }

  public getGuardians(patientId: number): Observable<any> {
    return this._http.get<any>(
      `${this.apiRoot}/patient/${patientId}/guardian`,
      httpOptions
    );
  }

  public getTreatmentCoordinators(practiceId: number): Observable<TxCoordinatorDto[]> {
    return this._http.get<any[]>(
      `${this.apiRoot}/practice/txcoordinators/list?practiceId=${practiceId}`,
      httpOptions
    );
  }
}
